angular
    .module('deepLink')
    .config(DeepLinkConfig);

function DeepLinkConfig($routeProvider) {
    $routeProvider.when('/holidays/search', {
        template: '',
        controller: 'DeepLinkController',
        controllerAs: 'deepLinkCtrl'
    });
}
